/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ErrorDetail } from './ErrorDetail';

export const ProblemForbidden: core.serialization.ObjectSchema<
    serializers.ProblemForbidden.Raw,
    Truvity.ProblemForbidden
> = core.serialization.object({
    detail: core.serialization.string().optional(),
    errors: core.serialization.list(ErrorDetail).optional(),
    instance: core.serialization.string().optional(),
    status: core.serialization.number(),
    title: core.serialization.string(),
});

export declare namespace ProblemForbidden {
    export interface Raw {
        detail?: string | null;
        errors?: ErrorDetail.Raw[] | null;
        instance?: string | null;
        status: number;
        title: string;
    }
}
